/* Encounter ValueSets and constants */

// http://hl7.org/fhir/ValueSet/administrative-gender
export const administrativeGender = [
  {
    code: 'male',
    system: 'http://hl7.org/fhir/ValueSet/administrative-gender',
    display: 'Male',
    definition: 'Male.',
  },
  {
    code: 'female',
    system: 'http://hl7.org/fhir/ValueSet/administrative-gender',
    display: 'Female',
    definition: 'Female.',
  },
  {
    code: 'other',
    system: 'http://hl7.org/fhir/ValueSet/administrative-gender',
    display: 'Other',
    definition: 'Other.',
  },
  {
    code: 'unknown',
    system: 'http://hl7.org/fhir/ValueSet/administrative-gender',
    display: 'Unknown',
    definition: 'Unknown.',
  },
];

// http://hl7.org/fhir/ValueSet/marital-status
export const maritalStatus = [
  {
    code: 'A',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Annulled',
    definition: 'Marriage contract has been declared null and to not have existed',
  },
  {
    code: 'D',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Divorced',
    definition: 'Marriage contract has been declared dissolved and inactive',
  },
  {
    code: 'I',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Interlocutory',
    definition: 'Subject to an Interlocutory Decree.',
  },
  {
    code: 'L',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Legally Separated',
    definition: 'Legally Separated',
  },
  {
    code: 'M',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Married',
    definition: 'A current marriage contract is active',
  },
  {
    code: 'P',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Polygamous',
    definition: 'More than 1 current spouse',
  },
  {
    code: 'S',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Never Married',
    definition: 'No marriage contract has ever been entered',
  },
  {
    code: 'T',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Domestic partner',
    definition: 'Person declares that a domestic partner relationship exists.',
  },
  {
    code: 'U',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'unmarried',
    definition: 'Currently not in a marriage contract.',
  },
  {
    code: 'W',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
    display: 'Widowed',
    definition: 'The spouse has died',
  },
  {
    code: 'UNK',
    system: 'http://terminology.hl7.org/CodeSystem/v3-NullFlavor',
    display: 'unknown',
    definition: 'Description: A proper value is applicable, but not known.',
  },
];
